/**
 * API functions
 */

import Axios from 'axios'
import { APIImageBoxProps, DUMMY_IMAGE_BOX_PROP, ImageBoxData } from './types';

export interface ImageType {
  id: number,
  image: string,
  name: string,
}

export function distinct(value: string, index: number, self: string[]) { return self.indexOf(value.trim()) === index }

export function flatten(arr: any[][]): any[] {
  let res: any[] = []

  for (const i of arr) {
    res = res.concat(i)
  }

  return res
}

export async function getData(type: 'milestones' | 'community'): Promise<ImageBoxData[]> {
  try {
    const data = (await Axios.get(`/api/${type}/`)).data as APIImageBoxProps[]

    // Match images with data
    return data
      .map((entry) => ({ ...DUMMY_IMAGE_BOX_PROP, ...entry }))
      .map(
        (entry): ImageBoxData => (
          {
            ...entry,
            images: [
              entry.image,
              entry.image2,
              entry.image3,
              entry.image4,
              entry.image5,
            ]
              .filter((image) => image.trim() !== '')
              .filter((image) => image.startsWith('/files/')),
            startYear: parseInt(entry.startYear, 10),
            endYear: parseInt(entry.endYear, 10),
            extra: `${entry.extra}${parseInt(entry.endYear, 10) >= 2019 ? ',current' : ',complete'}`,
          }
        ))

  } catch (e) {
    throw new Error('Error getting data')
  }
}
